<template>
  <div class="slot-inspector-header">
    <sp-button
      v-if="showBack"
      class="slot-inspector-header__back"
      :data-testid="TestId.slotInspector.back"
      color="text"
      variant="text"
      size="small"
      icon="chevron-left"
      :label="t('back_label')"
      @click="handleBack"
    ></sp-button>

    <div class="slot-inspector-header__text">
      <h2 class="slot-inspector-header__title">{{ t("title") }}</h2>
      <p class="slot-inspector-header__record">
        <sp-icon :name="recordIcon" size="x-small"></sp-icon>
        <span>{{ recordLine }}</span>
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { t } from "#ce/apps/SpAdmin/SpSlotInspectorApp/i18n";

const props = defineProps({
  recordType: {
    type: String,
    default: "physician",
  },
  recordName: {
    type: String,
    default: "",
  },
  ehrId: {
    type: String,
    default: "",
  },
  showBack: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["back"]);

function handleBack() {
  emit("back");
}

const recordIcon = computed(() => (props.recordType === "location" ? "location-color" : "doctor-color"));
const recordLine = computed(() => [props.recordName, props.ehrId].filter(Boolean).join(" · "));
</script>

<style scoped lang="scss">
.slot-inspector-header {
  display: flex;
  align-items: center;
  gap: var(--sp-ref-scale-8);
  min-width: 0;

  // Matches sp-modal's close button, which takes the header's text color. No `--sp-sys-color-text` role exists,
  // so a `color="text"` button otherwise falls back to sp-button's #666.
  &__back {
    --sp-comp-button-text-variant-text-text-color: var(--sp-sys-color-on-surface);
  }

  &__text {
    min-width: 0;
  }

  &__title {
    margin: 0;
    font-family: var(--sp-sys-font-family-medium);
    font-size: var(--sp-sys-typescale-h3-font-size);
    font-weight: var(--sp-sys-font-weight-medium);
    line-height: var(--sp-ref-scale-28);
    color: var(--sp-sys-color-on-surface);
  }

  &__record {
    display: flex;
    align-items: center;
    gap: var(--sp-ref-scale-8);
    margin: var(--sp-ref-scale-2) 0 0;
    font-size: var(--sp-sys-typescale-small-font-size);
    font-weight: var(--sp-sys-font-weight-normal);
    line-height: var(--sp-ref-scale-20);
    color: var(--sp-sys-color-neutral-secondary);
  }
}
</style>
